'use client'

import { useEffect } from 'react'

import { trackViewDashboardPrioritas } from '@/utils/tracker/modules/prioritas'

import { DashboardItems } from '@/modules/Dashboard/DashboardItems'
import { ProductLogoList } from '@/modules/Dashboard/ProductLogoList'

import { HeadingTitleBlock } from '@/components/HeadingTitleBlock/HeadingTitleBlock'
import { PlatfromPrioritasIcon } from '@/components/Icons/PlatformPrioritasIcon'

import { METATAG } from '@/configs/constants'

export default function DashboardPrioritasPage() {
  useEffect(() => {
    trackViewDashboardPrioritas()
  }, [])

  return (
    <>
      <HeadingTitleBlock
        withIcon={true}
        withMapOverlay={true}
        icon={<PlatfromPrioritasIcon />}
        title={METATAG.PRIORITAS.title}
        desc={METATAG.PRIORITAS.description}
        trackerGaEventName="prioritas"
        trackerPageTitle="Platform Prioritas"
        className="pb-[29rem] md:pb-[18rem] lg:pb-56"
      />
      <ProductLogoList />
      <DashboardItems />
    </>
  )
}
